import React, { Component } from "react";
import _ from "lodash";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { IconButton, Typography, Button, List, ListItem, ListItemText, withStyles } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

// // Shared layouts
import { Close as CloseIcon, AccountBalance } from "@material-ui/icons";

// Component styles
import styles from "./styles";

class EditConnection extends Component {
  state = {
    editOpen: false
  };

  onCloseClick = () => {
    this.props.onClose(false);
  };

  displayIntents() {
    const { connection, connections } = this.props;

    const commonConn = _.filter(connections["common"], ["connectorName", connection["connectorName"]]);
    console.log(commonConn);
    if (commonConn.length == 0) {
      return (
        <React.Fragment>
          <Typography variant="h5">No tasks</Typography>
        </React.Fragment>
      );
    }
    const enabledIntents = _.map(connection.intents, "ID");
    let taskTotal =
      commonConn[0]["intents"] && commonConn[0].intents.length > 1
        ? commonConn[0].intents.length + " Intents"
        : commonConn[0].intents.length === 1
        ? "1 Intent"
        : "No Intents";
    return (
      <React.Fragment>
        <Typography variant="h5">Intents</Typography>
        <Typography variant="h5">{taskTotal}</Typography>
        <List dense={true}>
          {commonConn[0].intents.map((intent, index) => (
            <ListItem key={1000 + index}>
              <ListItemText primary={intent.title} />
              <ListItemText primary={intent.desc} />
              {_.includes(enabledIntents, intent.ID) ? (
                <Typography variant="h5">Enabled</Typography>
              ) : (
                <Typography variant="h5">Disabled</Typography>
              )}
            </ListItem>
          ))}
        </List>
      </React.Fragment>
    );
  }

  render() {
    const { classes, connection, edit } = this.props;
    if (!edit) {
      return <React.Fragment />;
    }
    const taskTotal =
      connection["intents"] && connection.intents.length > 1
        ? connection.intents.length + " Intents"
        : connection.intents.length === 1
        ? "1 Intent"
        : "No Intents";

    const buttonText = this.props.connection["auth_exists"] ? "EDIT" : "SETUP";
    return (
      <div className={classes.editRoot}>
        <div className={classes.editLeftSide} onClick={this.onCloseClick} />
        <div className={classes.editRightSide}>
          <div className={classes.editCloseContainer}>
            <IconButton variant="text" onClick={this.onCloseClick}>
              <CloseIcon className={classes.editCloseButton} />
            </IconButton>
          </div>
          <div className={classes.editTitleRow}>
            <IconButton variant="text">
              <AccountBalance />
            </IconButton>
            <Typography className={classes.title} variant="h4">
              {connection.connectorName}
            </Typography>
            <Typography className={classes.connectorTitle} variant="h5">
              {taskTotal}
            </Typography>
          </div>

          <Typography variant="h5">DESC TODO</Typography>
          <Button
            variant="contained"
            size="large"
            color="primary"
            className={classes.margin}
            onClick={this.props.openDialog}
          >
            {buttonText}
          </Button>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            className={classes.margin}
            onClick={this.props.openDialog}
          >
            DOCUMENTATION
          </Button>
          <div>{this.displayIntents()}</div>
        </div>
      </div>
    );
  }
}

EditConnection.propTypes = {
  classes: PropTypes.object.isRequired,
  connection: PropTypes.object,
  onClose: PropTypes.func,
  openDialog: PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

function mapStateToProps(state) {
  return {
    intentCreated: state.intents.intentCreated,
    connections: state.connections ? state.connections : {},
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(EditConnection))
);
